module.exports = __webpack_public_path__ + "img/massage.6601b10c.png";